<template>
  <section :class="classes">
    <DataTable
      data-id="zapier-new-emails-table"
      :disable-delete="true"
      :disable-edit="true"
      :disable-new="true"
      :fields="fields"
      :items="items"
      :loading="loading"
      :page="page"
      :pageable="pageable"
      :total-elements="totalElements || undefined"
      icon="zapier"
      title="New emails"
      @page="handlePage"
      @refresh="refresh"
    />
  </section>
</template>
<script setup lang="ts">
import type { ZapierNewEmail } from '@mailslurp/admin-sdk';
import type { Field } from '../../lib/services/helpers';
import { loadFetch } from '../../lib/services/helpers';
import DataTable from '../../components/table/parts/DataTable.vue';
import { computed, onMounted, ref } from 'vue';

import { useStore3 } from '../../store/main';
import { storeToRefs } from 'pinia';

withDefaults(defineProps<{ classes?: string }>(), {
  classes: '',
});
const page = ref(0);
const size = ref(10);
const loading = ref(false);
const fields: Field<ZapierNewEmail>[] = [
  { key: 'id', label: 'ID', uuid: true },
  { key: 'seen', label: 'Seen' },
  { key: 'createdAt', label: 'Created', ago: true },
];

const store3 = useStore3();

const { zapierNewEmailRecords } = storeToRefs(store3);
const pagination = computed(() => zapierNewEmailRecords.value);
const items = computed(() => pagination.value?.content ?? []);
const pageable = computed(() => pagination.value?.pageable ?? null);
const totalElements = computed(() => pagination.value?.totalElements ?? null);

onMounted(async () => {
  await refresh();
});

const handlePage = async (id: number) => {
  page.value = id;
  await refresh();
};

const refresh = async () => {
  await loadFetch(
    () => store3.getZapierNewEmails({ page: page.value, size: size.value }),
    store3,
    loading,
  );
};
</script>
